var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grafico-holder"},[_c('apexchart',{key:_vm.processo.oid+_vm.id,staticClass:"justify-center",attrs:{"type":"bar","width":"100%","height":"4500","options":_vm.barOptions,"series":_vm.barSeries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }